import { render, staticRenderFns } from "./bingli_tab0.vue?vue&type=template&id=391e21e4&scoped=true&"
import script from "./bingli_tab0.vue?vue&type=script&lang=js&"
export * from "./bingli_tab0.vue?vue&type=script&lang=js&"
import style0 from "./bingli_tab0.vue?vue&type=style&index=0&id=391e21e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391e21e4",
  null
  
)

export default component.exports